export default __webpack_public_path__ + "static/media/269.3b2897e2.jpg";